import React from 'react';
import { RouterProvider } from 'react-router-dom';
import { router } from './router';

function App() {
  // RouterProvider separates logic from App component
  return <RouterProvider router={router} />;
}

export default App;
